import { PortfolioApi } from "@iliotech/generated-api-v3";
import { useQuery } from "react-query";
import { API_BASE } from "../../../main";

export const usePortfolioInfo = (portfolioId: string) => {
  const api = new PortfolioApi(undefined, `${API_BASE}/api`);
  return useQuery([`portfolio`, { portfolioId }], () => api.get2(portfolioId), {
    enabled: !!portfolioId,
  });
};
